export default __webpack_public_path__ + "static/media/slide8.c7988358.jpg";